import { useTheme } from '@/state/application/hooks'
import {
  TThemeOption,
  loadThemeFromLocalStorage
} from '@/state/application/reducer'
import { useAppDispatch } from '@/state/hooks'
import { useEffect, ReactElement } from 'react'
import { Moon, SunMoon } from 'lucide-react'
import { ConfigProvider } from 'antd'

export function AppThemeInit() {
  const dispatch = useAppDispatch()
  const [currentTheme] = useTheme()

  const reRenderTheme = () => {
    const autoDark = window.matchMedia('(prefers-color-scheme: dark)').matches

    if (currentTheme === 'dark' || (currentTheme === 'auto' && autoDark)) {
      document.body.classList.add('dark')
    } else {
      document.body.classList.remove('dark')
    }
  }

  useEffect(() => {
    dispatch(loadThemeFromLocalStorage())
  }, [dispatch])

  useEffect(reRenderTheme, [currentTheme])

  return null
}

export default function ThemeToggle(): ReactElement {
  const [currentTheme, setTheme] = useTheme()

  const toggleTheme = () => {
    setTheme(currentTheme === 'dark' ? 'light' : 'dark')
  }
  return (
    <div onClick={toggleTheme}>
      {currentTheme === 'dark' ? (
        <Moon size={24} color="#ffffff" />
      ) : (
        <SunMoon size={24} />
      )}
    </div>
  )
}
